export enum AdminAlertType {
  SystemAlert = 0,
  SecurityAlert = 1,
  PaymentAlert = 2,
  ComplianceAlert = 3,
  PerformanceAlert = 4,
  UserActionRequired = 5,
}
